module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-down-left-b57dff3d6933b41e0ed8ce6a99267a37.svg";